import * as Dialog from "@radix-ui/react-dialog";
import * as Tabs from "@radix-ui/react-tabs";
import { useState } from "react";
import { MdClose } from "react-icons/md";
import { Admin } from "types/auth";
import { Credentials } from "./Credentials";
import { TwoFactorSetup } from "./TwoFactorSetup";

type AdminFormProps = {
  admin?: Admin;
  admins: Admin[];
  children?: React.ReactNode;
  onSuccess: () => void;
};

export function AdminForm({
  admins,
  admin,
  children,
  onSuccess,
}: AdminFormProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = (isOpen: boolean) => {
    setIsOpen(isOpen);

    if (isOpen) return;
  };

  return (
    <>
      <Dialog.Root open={isOpen} onOpenChange={handleOpenChange} modal>
        <Dialog.Trigger asChild>{children}</Dialog.Trigger>
        <Dialog.Portal>
          <Dialog.Overlay className="data-[state=open]:animate-overlayShow fixed inset-0 z-50 bg-gray-800 bg-opacity-50" />
          <Dialog.Content className="data-[state=open]:animate-contentShow fixed left-[50%] top-[50%] z-[60] max-h-[85vh] w-[90vw] max-w-[450px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none dark:bg-gray-800 dark:text-white">
            <Tabs.Root className="flex w-full flex-col" defaultValue="tab1">
              <Tabs.List
                className="flex shrink-0 border-b"
                aria-label="Manage your account"
              >
                <Tabs.Trigger
                  className="text-mauve11 hover:text-violet11 data-[state=active]:text-violet11 data-[state=active]:shadow-current data-[state=active]:focus:shadow-black flex h-[45px] flex-1 cursor-default cursor-pointer select-none items-center justify-center bg-white px-5 text-[15px] leading-none outline-none first:rounded-tl-md last:rounded-tr-md data-[state=active]:shadow-[inset_0_-1px_0_0,0_1px_0_0] data-[state=active]:focus:relative"
                  value="tab1"
                >
                  <h2 className="text-mauve12 text-[17px] font-medium">
                    {!admin ? "Add new" : "Edit"} admin
                  </h2>
                </Tabs.Trigger>
                <Tabs.Trigger
                  className="text-mauve11 hover:text-violet11 data-[state=active]:text-violet11 data-[state=active]:shadow-current data-[state=active]:focus:shadow-black flex h-[45px] flex-1 cursor-default cursor-pointer select-none items-center justify-center bg-white px-5 text-[15px] leading-none outline-none first:rounded-tl-md last:rounded-tr-md disabled:text-gray-700 data-[state=active]:shadow-[inset_0_-1px_0_0,0_1px_0_0] data-[state=active]:focus:relative"
                  value="tab2"
                  disabled={!admin}
                >
                  <h2 className="text-mauve12 text-[17px] font-medium">2FA</h2>
                </Tabs.Trigger>
              </Tabs.List>

              <Tabs.Content
                className="focus:shadow-black grow rounded-b-md bg-white p-5 outline-none "
                value="tab1"
              >
                <Credentials
                  admins={admins}
                  admin={admin}
                  onSuccess={onSuccess}
                  handleOpenChange={() => handleOpenChange(false)}
                />
              </Tabs.Content>

              <Tabs.Content
                className="focus:shadow-black grow rounded-b-md bg-white p-5 outline-none "
                value="tab2"
              >
                <TwoFactorSetup admin={admin} />
              </Tabs.Content>
            </Tabs.Root>

            <Dialog.Close asChild>
              <button
                type="button"
                className="text-violet11 hover:bg-violet4 focus:shadow-violet7 absolute right-[10px] top-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
                aria-label="Close"
              >
                <MdClose />
              </button>
            </Dialog.Close>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
}
